import { makeStyles, tokens } from '@fluentui/react-components';

export const useBroadcastMessageStatsStyles = makeStyles({
    root: {
        display: 'flex',
        flexDirection: 'row',
        width: '100%',
        overflow: 'hidden',
        gap: tokens.spacingHorizontalS,
    },
    pendingSendingIcon: {
        color: tokens.colorBrandForeground2,
    },
    successfullySentIcon: {
        color: tokens.colorStatusSuccessBackground3,
    },
    sendFailedIcon: {
        color: tokens.colorStatusDangerBackground3,
    },
    throttledIcon: {
        color: tokens.colorStatusWarningBackground3,
    },
    acknowledgedIcon: {
        color: tokens.colorBrandForeground2,
        margin: `0 0 0 ${tokens.spacingHorizontalM}`,
    },
});
